import config from './config.json'
export const { serverPath, clientPath  } = config[process.env.REACT_APP_NODE_ENV]